import React from "react";
import { HStack, Icon, Text } from "@chakra-ui/react";
import { FaTruck, FaWalking } from "react-icons/fa";
import { DeliveryModes } from "../views/Orders/enums";

interface DeliveryModeBadgeProps {
  mode?: DeliveryModes | null;
}

const DeliveryModeBadge: React.FC<DeliveryModeBadgeProps> = ({ mode }) => {
  const getDeliveryModeConfig = (value?: DeliveryModes | null) => {
    switch (value) {
      case DeliveryModes.DOOR_DELIVERY:
        return {
          icon: FaTruck,
          label: "Door Delivery",
          color: "blue.600",
        } as const;
      case DeliveryModes.SELF_PICKUP:
        return {
          icon: FaWalking,
          label: "Self Pickup",
          color: "green.600",
        } as const;
      default:
        return {
          icon: undefined,
          label: "-",
          color: "gray.500",
        } as const;
    }
  };

  const config = getDeliveryModeConfig(mode);

  return (
    <HStack spacing={1} align="center">
      {config.icon && <Icon as={config.icon} boxSize={3.5} color={config.color} />}
      <Text fontSize="xs" color="gray.700" fontWeight="600">
        {config.label}
      </Text>
    </HStack>
  );
};

export default DeliveryModeBadge; 